module.exports = __webpack_public_path__ + "static/media/hydra-logo.85c31605.png";